import { __generator } from "tslib";
import { call, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { getCurrentUser } from '../../publicSession/selectors';
import { request } from '../../xhr';
import { MediaSourceType } from '../types';
import { SCRAPS_FOLDER_ID, ALL_FOLDER_ID } from '@wix/da-url';
import { getGallectionType } from '../helpers';
import { normalizeDeviations } from '../../redux/normalizr/helpers';
export function fakeResponse(_a) {
    var params = _a.params;
    if (process.env.NODE_ENV !== 'production') {
        var deviationsByType = require('@wix/da-sample-data').deviationsByType; // eslint-disable-line global-require
        var Chance = require('chance').Chance; // eslint-disable-line global-require
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error',
            };
        }
        var folderId = params.folderId, offset = params.offset, limit = params.limit;
        if (folderId === -999) {
            return {
                hasMore: false,
                nextOffset: 0,
                results: [],
            };
        }
        var randomDeviations = new Chance().pickset(deviationsByType.pixel
            .concat(deviationsByType.statuses)
            .concat(deviationsByType.image)
            .concat(deviationsByType.edgeCases)
            .concat(deviationsByType.journal)
            .concat(deviationsByType.literature), limit);
        return {
            hasMore: offset + limit < deviationsByType.image.length,
            nextOffset: offset + limit,
            results: randomDeviations.slice(0, limit),
        };
    }
}
function fetch(url, params) {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: url,
                    params: params,
                }, fakeResponse)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
        }
    });
}
function handleDeviationStreamFetch(action) {
    var streamId, streamParams, folderId, mediaSource, searchQuery, _a, currentUser, offset, limit, url, params, gallerySearchParams, faveSearchParams, gallectionContentsEndpointParams, response, hasMore, results, nextOffset, normalized;
    var _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                streamId = action.streamId;
                return [4 /*yield*/, select(selectors.getStreamParamsSafe, streamId)];
            case 1:
                streamParams = _e.sent();
                folderId = streamParams.folderId, mediaSource = streamParams.mediaSource, searchQuery = streamParams.searchQuery;
                return [4 /*yield*/, select(function (state) { return ({
                        currentUser: getCurrentUser(state),
                        offset: withOffset.selectors.getNextOffset(state, streamId),
                        limit: selectors.getItemsPerFetch(state, streamId),
                    }); })];
            case 2:
                _a = _e.sent(), currentUser = _a.currentUser, offset = _a.offset, limit = _a.limit;
                url = '';
                params = {};
                if (searchQuery) {
                    if (mediaSource === MediaSourceType.GALLERY) {
                        url = 'galleries/search';
                        gallerySearchParams = {
                            userid: currentUser.userId,
                            q: searchQuery,
                            offset: offset,
                            limit: limit,
                        };
                        params = gallerySearchParams;
                    }
                    else if (mediaSource === MediaSourceType.COLLECTION) {
                        url = 'favourites/search';
                        faveSearchParams = {
                            faver_userid: currentUser.userId,
                            q: searchQuery,
                            offset: offset,
                            limit: limit,
                        };
                        params = faveSearchParams;
                    }
                }
                else {
                    url = 'gallection/contents';
                    gallectionContentsEndpointParams = {
                        username: currentUser.username,
                        type: (_b = getGallectionType(mediaSource)) !== null && _b !== void 0 ? _b : 'collection',
                        folderid: folderId,
                        offset: offset,
                        limit: limit,
                        mature_content: true,
                    };
                    if (folderId === SCRAPS_FOLDER_ID) {
                        gallectionContentsEndpointParams.scraps_folder = true;
                    }
                    else if (folderId === ALL_FOLDER_ID) {
                        gallectionContentsEndpointParams.all_folder = true;
                    }
                    params = gallectionContentsEndpointParams;
                }
                if (!url) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, call(fetch, url, params)];
            case 3:
                response = _e.sent();
                if (!!response) return [3 /*break*/, 5];
                return [4 /*yield*/, put(withOffset.actions.fetchFailure({
                        streamId: streamId,
                        errorMsg: 'Failed to fetch',
                    }))];
            case 4:
                _e.sent();
                return [2 /*return*/];
            case 5:
                hasMore = response.hasMore, results = response.results, nextOffset = response.nextOffset;
                normalized = results && normalizeDeviations(results);
                return [4 /*yield*/, put(withOffset.actions.fetchSuccessDeduped({
                        streamId: streamId,
                        hasMore: results ? !!hasMore : false,
                        items: (_c = normalized === null || normalized === void 0 ? void 0 : normalized.result) !== null && _c !== void 0 ? _c : [],
                        entities: (_d = normalized === null || normalized === void 0 ? void 0 : normalized.entities) !== null && _d !== void 0 ? _d : {},
                        nextOffset: nextOffset !== null && nextOffset !== void 0 ? nextOffset : undefined,
                    }))];
            case 6:
                _e.sent();
                return [2 /*return*/];
        }
    });
}
export default handleDeviationStreamFetch;
//# sourceMappingURL=gallectionDeviationStreamFetch.js.map